
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/donate",
      function () {
        return require("private-next-pages/[slug]/donate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/donate"])
      });
    }
  